import { Mui } from "@leap4/frontend";
import { useEffect, useState } from "react";

/** Seconds since mount: "07" under a minute, then "1:05". */
export const RunTimer = () => {
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    const started = Date.now();
    const id = setInterval(() => setSeconds(Math.floor((Date.now() - started) / 1000)), 1000);
    return () => clearInterval(id);
  }, []);
  const ss = String(seconds % 60).padStart(2, "0");
  return <Mui.Box component="span" sx={{ fontVariantNumeric: "tabular-nums" }}>{seconds < 60 ? ss : `${Math.floor(seconds / 60)}:${ss}`}</Mui.Box>;
};
